export const key = (state) => state.customerComments.key;